export default __webpack_public_path__ + "static/media/018-monkey.fc53fbc6.svg";